import { useForm } from "react-hook-form";
import InvalidFeedback from "../../components/invalid-feedback/invalid-feedback.component";
import { SystemUserService } from "../../services/system-user";
import { StorageService } from "../../services/storage";
import { STORAGE } from "../../constants";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";

function AuthPage() {
  const navigate = useNavigate();

  const [errorMsg, setErrorMsg] = useState('');
  const [showPass, setShowPass] = useState(false);
  
  const defaultValues = {
    email: "",
    password: "",
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isValid },
  } = useForm<typeof defaultValues>({
    mode: 'onChange',
    defaultValues,
  });

  const submit = async(payload: typeof defaultValues) => {
    try {
      const data = await SystemUserService.login(payload.email, payload.password);

      StorageService.save(STORAGE.TOKEN, data.token);

      const accout = data.user.account;

      const user = data.user;
      user.account = user.account?._id;

      StorageService.save(STORAGE.USER, user);
      StorageService.save(STORAGE.ACCOUNT, accout);

      if(data.user.role === 'root') {
        navigate('/');
      } else {
        navigate('/select-period');
      }
    } catch (error: any) {
      setErrorMsg(error);
    }
  }

  return (
    <div className="d-flex flex-column flex-root">
      <div className="d-flex flex-column flex-lg-row flex-column-fluid">
        <div className="d-flex flex-column flex-lg-row-fluid py-10">
          <div className="d-flex flex-center flex-column flex-column-fluid">
            <div className="w-lg-500px p-10 p-lg-15 mx-auto">
              <form className="form w-100" onSubmit={handleSubmit(submit)}>
                <div className="text-center mb-10">
                  <img
                    alt="Aguacatecnia"
                    className="h-100px mb-7"
                    src="/assets/media/logos/logo-default.svg"
                  />
                  <h1 className="text-gray-900 mb-3">Inicio de sesión</h1>
                  <div className="text-gray-500 fw-semibold fs-4">
                    Bienvenido a Aguacatecnia
                  </div>
                </div>

                {
                  errorMsg && (
                    <div className="alert alert-danger mb-7">
                      {errorMsg}
                    </div>
                  )
                }
                
                <div className="fv-row mb-10">
                  <label className="form-label fs-6 fw-bold text-gray-900">
                    Correo
                  </label>
                  <input
                    className={`form-control form-control-lg form-control-solid ${(errors.email ? 'is-invalid' : '')}`}
                    type="text"
                    {...register('email', { required: true })}
                  />
                  <InvalidFeedback error={errors.email} />
                </div>
                <div className="fv-row mb-10">
                  <div className="d-flex flex-stack mb-2">
                    <label className="form-label fw-bold text-gray-900 fs-6 mb-0">
                      Password
                    </label>
                    <Link
                      className="link-primary fs-6 fw-bold"
                      to={'/auth/reset-password'}
                    >
                      ¿Olvidaste tu contraseña?
                    </Link>
                  </div>
                  <div className="input-group mb-3">
                    <input
                      className={`form-control form-control-lg form-control-solid ${(errors.password ? 'is-invalid' : '')}`}
                      type={`${ showPass ? 'text': 'password'}`}
                      {...register('password', { required: true })}
                    />
                    <button className="btn btn-bg-light" type="button" onClick={() => setShowPass(!showPass)}>
                      <i className={`bi bi-eye-${showPass ? 'slash-': ''}fill`} id="iconToggle"></i>
                    </button>
                  </div>
                  <InvalidFeedback error={errors.password} />
                </div>
                <div className="text-center">
                  <button
                    className="btn btn-lg btn-primary w-100 mb-5"
                    disabled={!isValid || isSubmitting}
                    onClick={handleSubmit(submit)}
                    type="submit"
                  >
                    {
                      isSubmitting ? (
                        <span className="indicator-progress d-block">
                          Espere por favor...
                          <span className="spinner-border spinner-border-sm align-middle ms-2" />
                        </span>
                      ): (
                        <span className="indicator-label">Continuar</span>
                      )
                    }
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuthPage;
